var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9CA9BD",
    fillRule: "nonzero",
    d: "M14.978 12.947a1.12 1.12 0 0 0-1.138.006l-1.78 1.06c-.397.237-.895.21-1.26-.076-.631-.493-1.648-1.322-2.532-2.207S6.554 9.83 6.06 9.198a1.11 1.11 0 0 1-.076-1.26l1.06-1.78c.21-.351.212-.789.005-1.142L4.44.557A1.125 1.125 0 0 0 3.196.033C2.725.148 2.112.428 1.47 1.07-.543 3.083-1.611 6.477 5.956 14.044s10.96 6.5 12.973 4.486c.644-.644.923-1.258 1.039-1.731a1.12 1.12 0 0 0-.522-1.237c-1.075-.628-3.393-1.986-4.468-2.615"
  })));
};
export default SvgPhone;